import React, { useEffect, useState, useRef } from 'react';
import * as VideoExpress from '@vonage/video-express';
import BlurOn from '@material-ui/icons/BlurOn';
import { useParams } from 'react-router-dom';
import BlurCircular from '@material-ui/icons/BlurCircular';
import BlockIcon from '@material-ui/icons/Block';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStyles from './styles';

// const backgroundImages = ['studyTable', 'sofabackground'];

function VideoFilter({ handleChangeVideoFilter }) {
  const classes = useStyles();
  const params = useParams();
  const [backgroundImages, setBackgroundImages] = useState([
    'studyTable',
    'sofabackground',
  ]);
  const apiCalled = useRef(false);
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    if (apiCalled.current) return;

    const fetchData = () => {
      const userData = JSON.parse(sessionStorage.getItem('userData'));

      fetch(`${process.env.REACT_APP_API_URL}/v2/layout/videocards`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userData?.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              throw new Error('Unauthorized');
            }
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          apiCalled.current = true;
          if (
            data.result.liveMeetBackgroundImageUrl !== '' &&
            data.result.liveMeetBackgroundImageUrl !== null
          ) {
            setBackgroundImages((prevImages) => [
              ...prevImages,
              data.result.liveMeetBackgroundImageUrl,
            ]);
          }
        })
        .catch((error) => {
          if (error.message === 'Unauthorized') {
            console.log('Retrying API call in 2 seconds due to 401 error...');
            setTimeout(fetchData, 2000); // Retry the API call after 2 seconds
          } else {
            console.log(error);
          }
        });
    };

    fetchData(); // Initial API call
  }, []);

  const applyFilter = async (filterName, filterPayload) => {
    setLoading(true);
    switch (filterName) {
      case 'backgroundImage':
        const imageEl =
          filterPayload && filterPayload?.includes('https')
            ? filterPayload
            : await loadImage(filterPayload);
        await handleChangeVideoFilter('backgroundImage', imageEl);
        break;
      default:
        await handleChangeVideoFilter(filterName, filterPayload);
    }
    setLoading(false);
  };

  const loadImage = (name) => {
    return fetch(`${process.env.PUBLIC_URL}/backgrounds/${name}.jpeg`)
      .then((res) => res.blob())
      .then((blob) => blobToBase64(blob))
      .then((base64) => {
        return base64;
      });
  };

  const blobToBase64 = (blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  if (VideoExpress?.hasMediaProcessorSupport()) {
    return (
      <div className={classes.videoFilterContainer}>
        <p>Background Options</p>
        <div className={classes.flex}>
          {loading && (
            <div className={classes.backgroundLoading}>
              <CircularProgress />
            </div>
          )}
          <div
            className={classes.buttonContainer}
            onClick={() => applyFilter('reset', '')}
          >
            <BlockIcon
              style={{
                transform: 'scale(1.5)',
                position: 'absolute',
                top: 'calc(50% - 10px)',
                left: 'calc(50% - 10px)',
                fontSize: '21px',
              }}
            />
          </div>
          <div
            className={classes.buttonContainer}
            onClick={() => applyFilter('blur', 'low')}
          >
            <BlurOn
              style={{
                transform: 'scale(1.5)',
                position: 'absolute',
                top: 'calc(50% - 10px)',
                left: 'calc(50% - 10px)',
                fontSize: '21px',
              }}
            />
          </div>
          <div
            className={classes.buttonContainer}
            onClick={() => applyFilter('blur', 'high')}
          >
            <BlurCircular
              style={{
                transform: 'scale(1.5)',
                position: 'absolute',
                top: 'calc(50% - 10px)',
                left: 'calc(50% - 10px)',
                fontSize: '21px',
              }}
            />
          </div>

          {backgroundImages.map((img, index) => (
            <img
              key={index}
              onClick={() => applyFilter('backgroundImage', img)}
              className={classes.backgroundImage}
              src={
                img && img?.includes('https')
                  ? img
                  : `${process.env.PUBLIC_URL}/backgrounds/${img}.jpeg`
              }
              alt={`Background ${img}`}
            />
          ))}
        </div>
      </div>
    );
  }
  return null;
}

export default VideoFilter;
